var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-icon',{attrs:{"color":"blue darken-1"},on:{"click":function($event){_vm.visible = !_vm.visible}}},[_vm._v("mdi-information-outline\n  ")]),(_vm.visible)?_c('span',[_vm._v(_vm._s(_vm.$t(_vm.text)))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }